import { Component } from '@angular/core';

@Component({
  selector: 'app-view-chordsteps',
  templateUrl: './Chordsteps.html',
  styleUrls: ['./style.css']
})
export class AppViewChordsteps {
  public conf = {
    instrument: 'guitar',
    show: {
      minor: false,
      major: true,
    },
    notes: ['C', 'D', 'E', 'F', 'G', 'A', 'B'],
    chordsteps: [1,2,3,4,5,6],
  };
  public notes = ['C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B'];

  public getStep(chord: string, level: number = 0): string {
    const isMinor = chord.endsWith('m') || chord.endsWith('b');
    const cleanChord = chord.replace(/[^A-H#]/, '');

    let step = (level-1) * 2;
    if (level > (isMinor ? 2 : 3)) {
      step -= 1;
    }
    if (level === 6 && isMinor) {
      step -= 1;
    }
    const tune = this.notes[(this.notes.indexOf(cleanChord) + step) % this.notes.length];

    if (isMinor) {
      if (level === 2) {
        return tune + 'dim';
      }
      if ([4,5].indexOf(level) >= 0) {
        return tune + 'm';
      }
    } else {
      //DUR
      if ([2,3,6].indexOf(level) >= 0) {
        return tune + 'm';
      }
      if (level === 7) {
        return tune + 'dim';
      }
    }
    return tune;
  }
}
